export const PrintIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22">
		<path
			fill="#06519E"
			d="M4 18L3 18C1.346 18 0 16.65 0 15L0 10C0 8.3500004 1.346 7 3 7L4 7L4 1C4 0.44999999 4.448 0 5 0L17 0C17.552999 0 18 0.44999999 18 1L18 7L19 7C20.653999 7 22 8.3500004 22 10L22 15C22 16.65 20.653999 18 19 18L18 18L18 21C18 21.549999 17.552999 22 17 22L5 22C4.448 22 4 21.549999 4 21L4 18ZM19 9C19.552 9 20 9.4499998 20 10L20 15C20 15.55 19.552 16 19 16L18 16L18 13C18 12.45 17.552999 12 17 12L5 12C4.448 12 4 12.45 4 13L4 16L3 16C2.4489999 16 2 15.55 2 15L2 10C2 9.4499998 2.4489999 9 3 9L19 9ZM16 14L6 14L6 20L16 20L16 14ZM16 2L16 7L6 7L6 2L16 2Z"
			fillRule="evenodd"
		/>
	</svg>
);
